import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const EmptyStateSection = ({ headerText }: { headerText: string }) => {
  const isMobile = useCheckMobileScreen()

  return (
    <Stack
      borderRadius="20px"
      width={isMobile ? '100%' : '700px'}
      p={isMobile ? '24px' : '97px 167px'}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap="16px">
      <Typography
        variant="h3.75"
        sx={{
          color: COLORS.GRAY_5,
        }}>
        {headerText}
      </Typography>
    </Stack>
  )
}

export default EmptyStateSection
